import React from "react";
import { withStyles } from "@material-ui/core/styles";

import { ListText } from "../styleguide";

const styles = () => ({
    listItemStyle: {
        listStyleType: "none",
        paddingLeft: 11,
        position: "relative",
    },
    listBulletStyle: {
        position: "absolute",
        top: 9,
        left: 0,
        color: "#e40045",
    },
});

const ListBullet = ({ className }) => (
    <svg width="6" height="6" viewBox="0 0 6 6" className={className} xmlns="http://www.w3.org/2000/svg">
        <rect x="0" y="0" width="6" height="6" fill="currentColor" stroke="none" />
    </svg>
);

const ListItem = ({ children, classes: { listItemStyle, listBulletStyle, listTextStyle } }) => (
    <li className={listItemStyle}>
        <ListBullet className={listBulletStyle} />
        <ListText className={listTextStyle}>{children}</ListText>
    </li>
);

export default withStyles(styles)(ListItem);



// WEBPACK FOOTER //
// ./src/components/ListItem.js